import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=5dce4555&scoped=true"
import script from "./basic_info.vue?vue&type=script&lang=js"
export * from "./basic_info.vue?vue&type=script&lang=js"
import style0 from "./basic_info.vue?vue&type=style&index=0&id=5dce4555&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce4555",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dce4555')) {
      api.createRecord('5dce4555', component.options)
    } else {
      api.reload('5dce4555', component.options)
    }
    module.hot.accept("./basic_info.vue?vue&type=template&id=5dce4555&scoped=true", function () {
      api.rerender('5dce4555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/abnormal_report_details/components/basic_info.vue"
export default component.exports